import React, { useEffect, useState } from 'react';
import styles from 'components/otp-button/index.module.scss';
import classname from 'classnames/bind';
import { useInterval } from 'helpers/time-helper';

const cx = classname.bind(styles);

const OTP_COUNT_DOWN_TIME_OF_SECONDS = 80;

const OtpButton = ({
  enabled,
  countDownTimes = OTP_COUNT_DOWN_TIME_OF_SECONDS,
  startCountDown = false,
  onClick,
  onTimesUp,
  children,
}) => {
  const [isStart, setIsStart] = useState(startCountDown);
  const [countDownTime, setCountDownTime] = useState(0);

  useInterval(
    () => {
      if (countDownTime >= countDownTimes) {
        setIsStart(false);
        setCountDownTime(0);
        if (onTimesUp) {
          onTimesUp();
        }
      } else {
        setCountDownTime(prev => prev + 1);
      }
    },
    startCountDown ? 1_000 : null
  );

  useEffect(() => {
    if (startCountDown) {
      setIsStart(true);
    }
  }, [startCountDown]);

  const buttonClasses = cx({
    button: true,
  });

  const Button = () => {
    if (isStart) {
      return <span className={styles['count-down-time']}>{`${countDownTimes - countDownTime} 秒後可重送`}</span>;
    } else {
      return (
        <button
          disabled={!enabled}
          className={buttonClasses}
          onClick={() => {
            if (onClick && !isStart) {
              onClick();
            }
          }}
        >
          {children}
        </button>
      );
    }
  };

  return <Button />;
};

export default OtpButton;
